import { addDoc, collection } from "firebase/firestore";
import { db } from "../utils/firebase-config";

export interface Feedback {
  uid: string;
  sentimentScore: number;
  title: string;
  body: string;
}

export function writeFeedback({
  uid,
  sentimentScore,
  title,
  body
}: Feedback) {
  return addDoc(collection(db, "feedback"), {
    uid,
    sentimentScore,
    title,
    body
  }).then(() => undefined);
}
